module.exports = __webpack_public_path__ + "img/chirurgie_digestive.2691f1d0.png";